import type { MonospaceProject } from '#layers/data-model';
import { RStoreSchema } from '#imports';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';
import { SystemMonospaceFile } from './file';

const PROJECT_DATETIME_FIELDS = ['dateCreated', 'dateUpdated'] as const;

export const Project = RStoreSchema.withItemType<MonospaceProject>().defineCollection({
	getKey: (item) => item.apiName ?? item.id,
	name: 'MonospaceProject',
	scopeId: 'monospace-default',
	fields: defineSystemDateTimeFields(PROJECT_DATETIME_FIELDS),
	meta: {
		defaultFields: [
			'id',
			'apiName',
			'displayName',
			'description',
			'defaultLanguage',
			'logoId',
			'primaryColor',
			'apiNamingConvention',
			'dbNamingConvention',
			'dateCreated',
			'dateUpdated',
		],
		endpoint: 'system/projects',
		fetchOnCreate: true,
		primitiveFieldTypes: defineSystemDateTimeFieldTypes(PROJECT_DATETIME_FIELDS),
	},
});

export const SystemProjectRelations = RStoreSchema.defineRelations(Project, ({ collection }) => ({
	logo: {
		to: collection(SystemMonospaceFile, {
			on: {
				'SystemMonospaceFile.id': 'MonospaceProject.logoId',
			},
		}),
	},
}));
